import { whitelabelConfig } from '../util'

export default function AuthorizationInterceptor(
  $q,
  $location,
  UserCache,
  WhitelabelService,
  cfpLoadingBar,
) {
  'ngInject'
  return {
    request: function (config) {
      cfpLoadingBar.start()

      if (config.url.indexOf('api/translate/qp2') !== -1) {
        return config || $q.when(config)
      }
      if (config.url.indexOf('glossary') !== -1) {
        return config || $q.when(config)
      }

      config.headers['X-Collectible-Platform'] = 'QP2'

      if ($location.$$path.indexOf('signin') === -1 && $location.$$path.indexOf('signup') === -1) {
        var auth = UserCache.getObject()
        if (auth) {
          config.headers.Authorization = 'Bearer ' + auth.jwt
        }
      }

      const wConfig = WhitelabelService.get()
      if (wConfig && wConfig.code) {
        config.headers['X-Collectible-Marketplace'] = wConfig.code
      } else {
        const getMktCode = whitelabelConfig(window.location.hostname)
        if (getMktCode) {
          config.headers['X-Collectible-Marketplace'] = getMktCode
        }
      }

      if (config.url.indexOf('automatic') !== -1) {
        config.headers['X-Collectible-QP2-Translation'] = 'true'
      }

      return config || $q.when(config)
    },
    response: function (response) {
      if (response.config.url.indexOf('marketplaces') === -1) {
        if (response.status === 401) {
          UserCache.remove()
          $location.path('/signin')
        }
      }
      cfpLoadingBar.complete()
      return response
    },
    responseError: function (rejection) {
      if (rejection.config.url.indexOf('marketplaces') === -1) {
        if (rejection.status === 401) {
          UserCache.remove()
          $location.path('/signin')
        }
      }

      cfpLoadingBar.complete()

      if (rejection.config.url.indexOf('marketplaces') === -1) {
        if (rejection && rejection.data && rejection.data.error) {
          swal(rejection.data.error.message, '', 'error')
        }
      }

      return $q.reject(rejection)
    },
  }
}
